import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export default function useIsMobile() {
  const { isMobile: isMobileServer } = useSelector(
    (state: any) => state.pageState,
  );

  const [isDetected, setIsDetected] = useState(false);
  const [isMobileClient, setIsMobileClient] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      if (typeof window !== "undefined") {
        setIsMobileClient(
          /Mobi|Android|iPhone/i.test(navigator.userAgent) ||
            window.innerWidth < 991,
        );
        setIsDetected(true);
      }
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return {
    isMobile: isDetected ? isMobileClient : isMobileServer,
    isDetected,
  };
}
